import { gql } from '@apollo/client';
import { SIMPLR_EXPERT_FIELDS_FRAGMENT } from './simplrExpertFieldsFragment.gql';

const SIMPLR_EXPERT_CREATE_SUBSCRIPTION = gql`
  ${SIMPLR_EXPERT_FIELDS_FRAGMENT}
  subscription onCreateSimplrExpert($input: SimplrExpertSubscriptionFilterInput) {
    onCreateSimplrExpert(input: $input) {
      ...SimplrExpertFields
    }
  }
`;

const SIMPLR_EXPERT_UPDATE_SUBSCRIPTION = gql`
  ${SIMPLR_EXPERT_FIELDS_FRAGMENT}
  subscription onUpdateSimplrExpert($input: SimplrExpertSubscriptionFilterInput) {
    onUpdateSimplrExpert(input: $input) {
      ...SimplrExpertFields
    }
  }
`;

const SIMPLR_EXPERT_ENTER_SUBSCRIPTION = gql`
  ${SIMPLR_EXPERT_FIELDS_FRAGMENT}
  subscription onEnterSimplrExpert($input: SimplrExpertSubscriptionFilterInput) {
    onEnterSimplrExpert(input: $input) {
      ...SimplrExpertFields
    }
  }
`;

export { SIMPLR_EXPERT_CREATE_SUBSCRIPTION, SIMPLR_EXPERT_UPDATE_SUBSCRIPTION, SIMPLR_EXPERT_ENTER_SUBSCRIPTION };
